import DapDSIcon from './icon.component'

export * from './icon.component'
export default DapDSIcon

DapDSIcon.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-icon': DapDSIcon
  }
}
